import type { InputStore } from '@/features/Sparten/res/useInputStore';

export const resInputDevMock: InputStore = {
  leistungsumfang: {
    vermietung: false,
    vermietungObjekteAnzahl: [0],
    mieten: false,
    anzahlFahrzeuge: 2,
    hasMehrereFahrzeuge: false,
    verkehr: false,
    beruf: false,
    privat: true,
    bruttojahresmieteBetrag0: undefined,
    bruttojahresmieteBetrag1: undefined,
    bruttojahresmieteBetrag2: undefined,
  },
  berufsstatus: 'Arbeitnehmer',
  tarifgruppe: 'Familie',
  selbstbeteiligung: '0',
  laufzeit: '1',
  demvRabattiert: true,
  vorschaden: 'nein',
  versicherungsbeginn: new Date('2022-11-17'),
  vorversicherung: 'nein',
  zahlweise: '1',
};
